// extracted by mini-css-extract-plugin
module.exports = {"FlexColumn":"FlexColumn_FlexColumn__hQaFI"};